<script setup>
import XerLoading from '@/components/XerLoading';
import XerZenomoLayout from '@/components/XerZenomoLayout';

import leadAanvraagApi from '@/api/lead-aanvraag.api';
import aanbodApi from '@/api/aanbod.api';
import { useNext } from '@/use/use-next';
import { useLeadAanvraagStore } from '@/stores/lead-aanvraag/lead-aanvraag';
import { useRouteExtensions } from '@/use/use-route-extensions';
import { ref } from 'vue';
const { aanvraagId, subflowNaam, currentRoute } = useRouteExtensions();
const aanbodRef = ref(undefined);
const { next } = useNext();

const leadAanvraagStore = useLeadAanvraagStore();

leadAanvraagApi
  .getLeadAanvraag({}, { aanvraagId: aanvraagId.value })
  .then(async (leadAanvraagResult) => {
    const leadAanvraag = leadAanvraagResult.leadAanvraag;

    leadAanvraag.start = currentRoute.value.query.start;
    leadAanvraagStore.updateLeadAanvraag(leadAanvraag);

    let overrideSubflowForNext = subflowNaam.value;

    const lang = leadAanvraag.taalCodeTypeCode == 2 ? 'nl' : 'fr';

    let aanbodDefinitie;
    aanbodDefinitie = await aanbodApi.getAanbodDefinitieByVersion(
      leadAanvraag.aanbodVersieId,
      leadAanvraag.subflowVersies.map((sf) => sf.subflowVersieId),
      lang
    );

    aanbodRef.value = aanbodDefinitie.aanbodNaam;

    // if not in subflow: handle out of subflow authentication and start first subflow
    if (!overrideSubflowForNext || overrideSubflowForNext == 'undefined') {
      overrideSubflowForNext = aanbodDefinitie.subflows[0].naam;
    }

    next(undefined, undefined, overrideSubflowForNext, aanbodRef.value);
  });
</script>

<template>
  <xer-zenomo-layout :hide-navbar="true">
    <div class="xer-flex xer-justify-center">
      <xer-loading />
    </div>
  </xer-zenomo-layout>
</template>
